import { BaseWebComponentView } from '../../../../../../../../framework/BaseWebComponentView';
import { GridViewWebComponent } from '../../../../../../../../grid/gridView';
import { WEB_COMPONENT_GRID_VIEW } from '../../../../../../../../webcomponents.constants';
import { ColumnDetails, ColumnType } from '../../../../../../../../grid/types/common';
import { translateFn } from '../../../../../../../../utils/translator.helper';
import { ProductsGridDataProvider } from '../dataProvider/ProductsGridDataProvider';
import { ProductsColumnIndexes, ProductsColumnKeys } from '../types';
import { InputWidthValues } from 'apps/webcomponents/src/ui/gzInput';

export class ProductsGridView extends BaseWebComponentView {
  public patchId: string;
  public productsCount: number;

  public dom: {
    $gridView: GridViewWebComponent<ProductsColumnIndexes, ProductsColumnKeys>;
  };

  getDomElements(): void {
    this.dom.$gridView = this.shadow.querySelector(WEB_COMPONENT_GRID_VIEW);

    if (this.dom.$gridView.injectDependencies) {
      this.dom.$gridView.injectDependencies(this.dependencies);
      this.dom.$gridView.start().then().catch(console.error);
    }
  }

  buildView(): void {
    this.buildGridView();
  }

  private buildGridView() {
    const columnDetails: Array<ColumnDetails<ProductsColumnIndexes, ProductsColumnKeys>> = [
      {
        key: ProductsColumnKeys.PRODUCT_NAME,
        column: ProductsColumnIndexes.PRODUCT_NAME,
        columnName: translateFn('Product'),
        type: ColumnType.STRING,
        removable: false,
        sortable: true,
        flexGrow: 0.7,
      },
      {
        key: ProductsColumnKeys.VENDOR_NAME,
        column: ProductsColumnIndexes.VENDOR_NAME,
        columnName: translateFn('Vendor'),
        type: ColumnType.STRING,
        removable: false,
        sortable: true,
        flexGrow: 0.3,
      },
    ];

    this.dom.$gridView.propertiesSet = false;
    this.dom.$gridView.dataProvider = new ProductsGridDataProvider(this.dependencies);
    (this.dom.$gridView.dataProvider as ProductsGridDataProvider).patchId = this.patchId;
    (this.dom.$gridView.dataProvider as ProductsGridDataProvider).productsCount = this.productsCount;
    this.dom.$gridView.hideHeaderActions = true;
    this.dom.$gridView.hideResetFilters = true;
    this.dom.$gridView.hideFiltersToggle = true;
    this.dom.$gridView.viewId = 'products-grid';
    this.dom.$gridView.columns = [ProductsColumnIndexes.PRODUCT_NAME, ProductsColumnIndexes.VENDOR_NAME];
    this.dom.$gridView.defaultFlexGrowColumn = ProductsColumnKeys.VENDOR_NAME;
    this.dom.$gridView.predefinedFiltersKeys = [ProductsColumnKeys.PRODUCT_NAME, ProductsColumnKeys.VENDOR_NAME];
    this.dom.$gridView.filters = [
      {
        [ProductsColumnKeys.PRODUCT_NAME]: { contains: '' },
      },
      {
        [ProductsColumnKeys.VENDOR_NAME]: { contains: '' },
      },
    ];
    this.dom.$gridView.allColumnDetails = columnDetails;
    this.dom.$gridView.hasSelectionExtraOptions = false;
    this.dom.$gridView.isCompactViewChecked = false;
    this.dom.$gridView.showToolbarRefresh = false;
    this.dom.$gridView.hasPagination = true;
    this.dom.$gridView.hideFooter = true;
    this.dom.$gridView.pageSize = 20;
    this.dom.$gridView.filtersUiConfigs = [
      {
        key: ProductsColumnKeys.PRODUCT_NAME,
        config: {
          inputWidth: InputWidthValues.MEDIUM,
        },
      },
      {
        key: ProductsColumnKeys.VENDOR_NAME,
        config: {
          inputWidth: InputWidthValues.MEDIUM,
        },
      },
    ];
    this.dom.$gridView.propertiesSet = true;
  }
}
